module.exports = __webpack_public_path__ + "static/Meetups-48542cf91b2cbd91b52f836f2d4c15aa.png";